import api from '../../models/kanbansuffix'
import swal from 'sweetalert2'
import kbseditmodal from '../../components/modal/kbsetup_edit_modal'

export default {
  name: 'kanbansuffix',
  components: {
    kbseditmodal
  },
  data() {
    return {
      search_text: '',
      dk_id: '',
      dk_code: '',
      dockList: [],
      pr_number: '',
      partList: [],
      pr_id_number: '',
      partidList: [],
      spl_plant_code: '',
      plantList: [],
      spl_id: '',
      spl_code: '',
      supplierList: [],
      ps_qty_pack: '',
      is_active: 1,
      isLoad: false,
      result_data: [],
      str_data: '',
      aisin: 0,
      read: 0,
      ordered: 0,
      current: 0,
      setup: 0,
      kbwait: 0,
      remarkList: [],
      prs_remark: '',
      // form
      ps_id: '',
      prs_ids: [],
      md_data: {
        ps_id: 0,
        aisin: 0,
        read: 0,
        ordered: 0,
        current: 0,
        setup: 0
      }
    }
  },
  created() {
    this.checkOAuth()
  },
  mounted() {
    setTimeout(() => {
      this.pr_id =
        this.$route.query.pr_id !== undefined
          ? this.$route.query.pr_id
          : this.pr_id
      this.pr_number =
        this.$route.query.pr_number !== undefined
          ? this.$route.query.pr_number
          : this.pr_number
      this.pr_id_number =
        this.$route.query.pr_id_number !== undefined
          ? this.$route.query.pr_id_number
          : this.pr_id_number
      this.ps_id =
        this.$route.query.ps_id !== undefined
          ? this.$route.query.ps_id
          : this.ps_id
      this.ps_qty_pack =
        this.$route.query.ps_qty_pack !== undefined
          ? this.$route.query.ps_qty_pack
          : this.ps_qty_pack
      this.plant_code =
        this.$route.query.plant_code !== undefined
          ? this.$route.query.plant_code
          : this.plant_code
      this.spl_id =
        this.$route.query.spl_id !== undefined
          ? this.$route.query.spl_id
          : this.spl_id
      this.spl_code =
        this.$route.query.spl_code !== undefined
          ? this.$route.query.spl_code
          : this.spl_code
      this.spl_name =
        this.$route.query.spl_name !== undefined
          ? this.$route.query.spl_name
          : this.spl_name
      this.spl_plant_code =
        this.$route.query.spl_plant_code !== undefined
          ? this.$route.query.spl_plant_code
          : this.spl_plant_code
      this.dk_id =
        this.$route.query.dk_id !== undefined
          ? this.$route.query.dk_id
          : this.dk_id
      this.dk_code =
        this.$route.query.dk_code !== undefined
          ? this.$route.query.dk_code
          : this.dk_code
      if (sessionStorage.token) {
        this.getRemark()        
        this.search()
      } else {
        setTimeout(() => {
          this.getRemark()          
          this.search()
        }, 1000)
      }
    }, 1000)
  },
  methods: {
    backTopage() {
      this.$router.push({
        name: 'Suffixsearch',
        params: {
          dock:
            typeof this.$route.query.dk_id !== 'undefined'
              ? this.$route.query.dk_id
              : '',
          part:
            typeof this.$route.query.pr_id !== 'undefined'
              ? this.$route.query.pr_id
              : '',
        },
      })
    },
    search() {
      this.isLoad = true
      this.aisin = 0
      this.read = 0
      this.ordered = 0
      this.current = 0
      this.setup = 0
      this.prs_ids = []
      this.md_data = {
        ps_id: 0,
        aisin: 0,
        read: 0,
        ordered: 0,
        current: 0,
        setup: 0
      }
      var obj = {
        ps_id: this.ps_id,
        dk_id: this.dk_id,
        pr_number: this.pr_number,
        pr_id_number: this.pr_id_number,
        prs_inout: this.is_active,
        spl_plant_code: this.spl_plant_code,
        spl_id: this.spl_id,
        ps_qty_pack: this.ps_qty_pack,
      }
      this.result_data = []
      this.header.params = obj
      if (this.part !== '' || this.partid !== '') {
        api.Reportallpartserial(
          this.$store.state.URLHost,
          this.header,
          (result) => {
            if (result.response === true) {
              this.result_data = result.data
              this.aisin = result.aisin
              this.read = result.read
              this.ordered = result.ordered
              this.current = result.current
              this.setup = result.setup
              this.md_data = {
                ps_id: this.ps_id,
                aisin: this.aisin,
                read: this.read,
                ordered: this.ordered,
                current: this.current,
                setup: this.setup
              }
              this.getKBWait()
            } else {
              this.alert_msg('warning', 'Kanban Suffix Search', result.message)
            }
            this.isLoad = false
          },
          (error) => {
            this.alert_msg('error', 'Kanban Suffix Search', error.message)
            this.isLoad = false
          }
        )
      } else {
        this.alert_msg(
          'warning',
          'Kanban Suffix Search',
          'Please select part number or part ID.'
        )
        this.isLoad = false
      }
    },
    getKBWait() {
      this.header.params = {}
      this.kbwait = 0
      api.getKanbanWait(
        this.$store.state.URLHost,
        this.ps_id,
        this.header,
        (result) => {
          if (result.response === true) {
            this.kbwait = result.sum_part_wait
          } else {
            this.alert_msg('warning', 'Get Kanban Waiting', result.message)
          }
        },
        (error) => {
          this.alert_msg('error', 'Get  Kanban Waiting', error.message)
        }
      )
    },
    getRemark() {
      this.remarkList = []
      this.header.params = {}
      api.getRemark(
        this.$store.state.URLHost,
        this.header,
        (result) => {
          if (result.response === true) {
            this.remarkList = result.data
          } else {
            this.alert_msg('warning', 'Get Remark', result.message)
          }
        },
        (error) => {
          this.alert_msg('error', 'Get Remark', error.message)
        }
      )
    },
    updateRemark(prs_id, prs_remark) {
      let formData = {
        prs_remark: prs_remark,
      }
      this.header.params = {}
      api.updateRemark(
        this.$store.state.URLHost,
        formData,
        prs_id,
        this.header,
        (result) => {
          if (result.response === true) {
            this.search()
            this.alert_msg('success', 'Update Remark', result.message)
          } else {
            this.search()
            this.alert_msg('warning', 'An error occurred.', result.message)
          }
        },
        (error) => {
          this.search()
          this.alert_msg('error', 'An error occurred.', error.message)
        }
      )
    },
    addStockOut() {
      if (this.prs_ids.length > 0) {
        swal
          .fire({
            title: 'Are you sure?',
            text:
              'Confirm add stock out : ' +
              this.prs_ids.length +
              ' part serial.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#67757c',
            confirmButtonText: 'Yes, do it!',
            cancelButtonText: 'Cancel',
          })
          .then((result) => {
            if (result.value) {
              this.is_load = true
              let formData = {
                ps_id: this.ps_id,
                prs_ids: this.prs_ids,
              }
              api.addStockOut(
                this.$store.state.URLHost,
                formData,
                this.header,
                (result) => {
                  if (result.response === true) {
                    this.search()
                    this.alert_msg('success', 'Add stock out', result.message)
                  } else {
                    this.search()
                    this.alert_msg(
                      'warning',
                      'An error occurred.',
                      result.message
                    )
                  }
                },
                (error) => {
                  this.search()
                  this.alert_msg('error', 'An error occurred.', error.message)
                }
              )
            }
          })
      } else {
        this.alert_msg('error', 'An error occurred.', 'Serial not selected.')
      }
    }
  },
}



// WEBPACK FOOTER //
// ./src/assets/js/kanbansuffix.js